import { LogoMark } from "./Logo";

const ITEMS = [
  "Study in the USA",
  "United Kingdom",
  "Germany",
  "Latvia",
  "Visa Counselling",
  "India Campus Advisory",
  "Twinning Partnerships",
  "Apprentice Placement",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" aria-hidden="true"
      className="bg-[#0B192C] border-y border-amber-500/20 py-5 overflow-hidden select-none">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={
                i % 2
                  ? "whitespace-nowrap font-heading italic text-lg sm:text-xl text-amber-400"
                  : "whitespace-nowrap text-sm sm:text-base uppercase tracking-[0.25em] font-semibold text-slate-300"
              }
            >
              {item}
            </span>
            <LogoMark className="w-4 h-4" dark />
          </span>
        ))}
      </div>
    </div>
  );
};
